import Model from 'flarum/common/Model';
import Tag from 'ext:flarum/tags/common/models/Tag';

// Registers champis-forum's custom Tag attributes (see the postCount and
// champisOrder fields added to TagResource in extend.php) exactly once -
// both addForumsMenu.js and redesignTagsPage.js need champisOrder, and
// Object.defineProperty throws if called twice for the same property on
// the same (shared, module-cached) Tag class.
let registered = false;

// Declaration merging: these 3 getters are real at runtime (added below,
// once) but aren't part of flarum-tags' own Tag typings - this is the
// standard TS way to extend another package's exported class with fields
// a local extend.php actually adds to its API resource.

export default function registerTagAttributes() {
  if (registered) return;
  registered = true;
  Object.defineProperty(Tag.prototype, 'postCount', {
    value: Model.attribute('postCount')
  });
  Object.defineProperty(Tag.prototype, 'champisOrder', {
    value: Model.attribute('champisOrder')
  });
  Object.defineProperty(Tag.prototype, 'rulesDiscussionId', {
    value: Model.attribute('rulesDiscussionId')
  });
}
flarum.reg.add('champis-forum', 'forum/utils/tagAttributes', registerTagAttributes);